import React from 'react';
import { styled } from 'linaria/react';
import { ComplementaryProducts } from './ComplementaryProducts';

export const ResultComponent = () => (
  <ResultContainer>
    <ComplementaryProducts />
  </ResultContainer>
);

const ResultContainer = styled.div`
  margin-bottom: var(--space-400);

  @media (--only-mobile) {
    padding: 0;
    border: 0;
    border-radius: 0;
  }
`;
